import { IRecommendFormValues } from '../components/RecommendModal/RecommendModal';
import api from './api';

async function postVacancyRecommendationAPI(data: IRecommendFormValues) {
  const formData = new FormData();
  formData.append('recommender_first_name', data.recommenderFirstName);
  formData.append('recommender_last_name', data.recommenderLastName);
  formData.append('recommender_patronymic', data.recommenderPatronymic);
  if (data.recommenderPhoneNumber) {
    formData.append('recommender_phone_number', data.recommenderPhoneNumber);
  }
  formData.append('recommender_email', data.recommenderEmail);
  formData.append('recommended_first_name', data.recommendedFirstName);
  formData.append('recommended_last_name', data.recommendedLastName);
  formData.append('recommended_patronymic', data.recommendedPatronymic);
  if (data.recommendedPhoneNumber) {
    formData.append('recommended_phone_number', data.recommendedPhoneNumber);
  }
  formData.append('recommended_email', data.recommendedEmail);
  formData.append('consent_to_be_recommended', String(data.concentToBeRecommended));
  formData.append('vacancy', String(data.vacancy));
  formData.append('check_IT', String(data.checkIT));
  if (data.cvFile) {
    formData.append('file', data.cvFile);
  }
  formData.append('check_PD', String(data.checkPersonalData));

  return api.post('/vacancy_recommendation/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });
}

export default postVacancyRecommendationAPI;
